export default __webpack_public_path__ + "static/media/group-4-copy.2f20a3c3.svg";